/*
         * @ngdoc function
         * @name ePay.Model:Session_ACHModel
         * @description
         * Model
         */

export class Session_ACHModel {
  accountName: string | null | undefined;
  routingNumber: string | null | undefined;
  accountNumber: string | null | undefined;

	constructor(
		accountName?: string, 
		routingNumber?: string, 
		accountNumber?: string
	) {
		this.accountName = accountName || null;
		this.routingNumber = routingNumber || null;
		this.accountNumber = accountNumber || null;
	}
}
